import React from 'react'

import { StylesConfig } from 'react-select'
import AsyncSelect from 'react-select/async'

const commonStyles = {
  background: '#ccfffb',
  color: '#222',
  fontFamily: 'Nista-Regular',
  fontWeight: 'normal'
}

const customStyles: StylesConfig = {
  input: (provided, state) => ({
    ...provided,
    ...commonStyles,
    margin: '0px',
    border: '0px',
    padding: '15px',
    paddingTop: '0px',
    paddingBottom: '0px',
    height: '50px',
    minHeight: '0px'
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    ...commonStyles,
    padding: '0px'
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    display: 'none'
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    ...commonStyles
  }),
  control: (provided, state) => ({
    ...provided,
    borderWidth: '0px',
    boxShadow: 'none'
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    ...commonStyles
  }),
  menu: (provided, state) => ({
    ...provided,
    ...commonStyles
  }),
  menuList: (provided, state) => ({
    ...provided,
    ...commonStyles
  }),
  option: (provided, state) => ({
    ...provided,
    ...commonStyles,
    background: state.isFocused ? '#1e90ff' : commonStyles.background,
    color: state.isFocused ? 'white' : commonStyles.color
  }),
  multiValue: (provided, state) => ({
    ...provided,
    ...commonStyles,
    padding: '10px'
  })
}

export const StyledSelect = (props: any) => {
  return (
    <AsyncSelect
      styles={customStyles}
      inputId='react-select-input'
      {...props}
    />
  )
}
